export const TOKENS = {
  color: {
    background: "#F8FAFC",
    surface: "#FFFFFF",
    surfaceMuted: "#F1F5F9",
    textPrimary: "#1E293B",
    textSecondary: "#475569",
    textMuted: "#64748B",
    border: "#CBD5E1",
    borderStrong: "#94A3B8",
    focus: "#0EA5E9",
    success: "#15803D",
    successBg: "#DCFCE7",
    error: "#B91C1C",
    errorBg: "#FEE2E2",
    warning: "#9A3412",
    warningBg: "#FFEDD5",
    infoBg: "#E0F2FE",
    infoText: "#075985",
    disabledBg: "#E2E8F0",
    disabledText: "#64748B",
    codeBg: "#0F172A",
    codeText: "#E2E8F0",
  },
  spacing: {
    xxs: 4,
    xs: 8,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 32,
    xxxl: 40,
  },
  radius: {
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    pill: 24,
  },
  shadow: {
    card: {
      shadowColor: "#0F172A",
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.08,
      shadowRadius: 8,
      elevation: 2,
    },
  },
  font: {
    regular: "Urbanist400",
    medium: "Urbanist500",
    semibold: "Urbanist600",
    bold: "Urbanist700",
    mono: "Courier",
  },
  fontSize: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    xxl: 24,
  },
  lineHeight: {
    xs: 16,
    sm: 20,
    md: 22,
    lg: 24,
    xl: 28,
  },
  zIndex: {
    base: 1,
    overlay: 10,
    modal: 20,
  },
  motion: {
    micro: 100,
    standard: 200,
    complex: 300,
  },
};

export default TOKENS;
